// Whitelist of the urls available for groups
const GROUP_WHITELIST = [
  'dashboard',
  'management',
  'management/stocks',
  'management/tickets',
  'management/movements',
  'management/places',
  'management/partners',
  'management/groupings',
  'relocalisation',
  'relocalisation/relocation-claims',
  'account',
  'account/profile',
  //'account/invoices',
  'account/users'
];

export class GroupsUtils {

  public static isInGroupWhitelist(url: string): { found: boolean, contains: string } {
    let found: boolean = false; // true if the given url is found in the whitelist
    let contains: string = ''; // contains the nearest path of the given url that is found in the whitelist
    for (let index = 0; index < GROUP_WHITELIST.length && !found; ++index) {
      const paths = url.split('?')[0];
      if (paths.includes(GROUP_WHITELIST[index])) {
        contains = GROUP_WHITELIST[index];
        found = paths.endsWith(GROUP_WHITELIST[index]);
      }
    }
    return { found, contains };
  }
}
